// ─── Shared styles — earthy orange palette ────────────────────────
const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid #7a2e00', fontFamily:"'Georgia',serif", color:'#1a0e06', lineHeight:'1.7', background:'#fdf6ee' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c45a10', paddingBottom:'8px', marginBottom:'24px', color:'#7a2e00' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#a04010', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c45a10', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#fdf0e4', border:'2px solid #c45a10', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New',monospace", fontSize:'0.88rem', color:'#7a2e00', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c45a10' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#a04010', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf4ec' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf6ee' },
  tdL:          { fontWeight:'600', color:'#7a2e00', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New',monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fdf4ec', border:'1px solid #e8b07a', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7a2e00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#7a4a28', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((it,i) => <div key={i} style={S.infoBoxItem}>{it}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{...S.th, width:'220px'}}>Concept</th>
        <th style={S.th}>Detail</th>
      </tr></thead>
      <tbody>{rows.map(([l,v],i) => (
        <tr key={i}>
          <td style={{...(i%2===0?S.tdE:S.tdO), ...S.tdL}}>{l}</td>
          <td style={{...(i%2===0?S.tdE:S.tdO), ...S.code}}>{v}</td>
        </tr>
      ))}</tbody>
    </table>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 1 — Latch Anatomy & Terminology
// Cross-section showing the universal parts every latch shares
// ─────────────────────────────────────────────────────────────────────
function DiagramLatchAnatomy() {
  const W = 960, H = 390;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Latch Anatomy — Universal Parts &amp; Terminology</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arLA" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <marker id="arLAb" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2a6496"/>
          </marker>
          <pattern id="hatchLA" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="6" stroke="#d4874a" strokeWidth="1.5" opacity="0.5"/>
          </pattern>
        </defs>

        {/* ── DOOR FRAME (keep) ── */}
        <rect x={60} y={80} width={30} height={240} fill="url(#hatchLA)" stroke="#7a2e00" strokeWidth="2"/>
        <text x={75} y={72} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Frame / Keep</text>

        {/* ── STRIKE PLATE ── */}
        <rect x={86} y={170} width={18} height={60} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5" opacity="0.85"/>
        <text x={104} y={165} fontSize="8.5" fontWeight="700" fill="#a04010">Strike plate</text>
        <line x1={104} y1={168} x2={104} y2={178} stroke="#a04010" strokeWidth="1"/>

        {/* ── DOOR PANEL ── */}
        <rect x={200} y={80} width={25} height={240} fill="#d4874a" stroke="#7a2e00" strokeWidth="2" opacity="0.6"/>
        <text x={212} y={72} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Door</text>

        {/* ── KEEP / STRIKER HOLE ── */}
        <rect x={90} y={185} width={14} height={32} rx={2} fill="#fdf6ee" stroke="#c45a10" strokeWidth="1.5"/>

        {/* ── LATCH BOLT ── */}
        <rect x={104} y={192} width={96} height={18} rx={3} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        {/* Angled face (cam) on leading edge */}
        <polygon points="104,192 104,210 90,201" fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={152} y={204} textAnchor="middle" fontSize="8.5" fontWeight="700" fill="#fff">Latch Bolt</text>

        {/* Cam / angled face callout */}
        <line x1={92} y1={196} x2={60} y2={155} stroke="#c45a10" strokeWidth="1.2"/>
        <rect x={4} y={130} width={110} height={30} rx={3} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={59} y={145} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a2e00">Cam / angled face</text>
        <text x={59} y={156} textAnchor="middle" fontSize="8" fill="#a04010">self-closes on contact</text>

        {/* ── RETURN SPRING ── */}
        {/* Spring coils between bolt and housing */}
        {[0,1,2,3,4].map(i => (
          <path key={i}
            d={`M ${210+i*8} 196 Q ${214+i*8} 192 ${218+i*8} 196 Q ${222+i*8} 200 ${226+i*8} 196`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}
        <line x1={200} y1={201} x2={210} y2={201} stroke="#7a4a28" strokeWidth="1.8"/>
        <line x1={250} y1={201} x2={260} y2={201} stroke="#7a4a28" strokeWidth="1.8"/>
        <text x={230} y={225} textAnchor="middle" fontSize="9" fontWeight="700" fill="#7a4a28">Return spring</text>
        <line x1={230} y1={218} x2={230} y2={200} stroke="#7a4a28" strokeWidth="1"/>

        {/* ── HOUSING / CASE ── */}
        <rect x={200} y={155} width={75} height={90} rx={4}
          fill="none" stroke="#7a2e00" strokeWidth="2.5" strokeDasharray="5,3"/>
        <text x={275} y={152} fontSize="9" fontWeight="700" fill="#7a2e00">Housing</text>

        {/* ── ACTUATOR (handle/thumb) ── */}
        <rect x={275} y={172} width={60} height={22} rx={4} fill="#2a6496" stroke="#7a2e00" strokeWidth="2" opacity="0.8"/>
        <text x={305} y={187} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">Actuator</text>
        <line x1={305} y1={172} x2={305} y2={155} stroke="#2a6496" strokeWidth="1.5" strokeDasharray="3,2"/>

        {/* ── DEADLOCKING / SECURITY ── */}
        <rect x={275} y={205} width={60} height={22} rx={4} fill="#7a2e00" stroke="#7a2e00" strokeWidth="1.5" opacity="0.75"/>
        <text x={305} y={220} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">Dead-lock</text>
        <text x={305} y={232} textAnchor="middle" fontSize="7.5" fill="#7a4a28">(optional)</text>

        {/* ── MOTION ARROWS ── */}
        {/* Bolt retraction direction */}
        <line x1={200} y1={218} x2={248} y2={218} stroke="#c45a10" strokeWidth="2" markerEnd="url(#arLA)" strokeDasharray="4,2"/>
        <text x={222} y={235} textAnchor="middle" fontSize="8" fill="#c45a10">retract</text>

        {/* Door close direction */}
        <line x1={226} y1={145} x2={204} y2={145} stroke="#2a6496" strokeWidth="2" markerEnd="url(#arLAb)"/>
        <text x={215} y={140} textAnchor="middle" fontSize="8" fill="#2a6496">close</text>

        {/* ── RIGHT FACTS PANEL ── */}
        <rect x={400} y={10} width={550} height={H-20} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={675} y={28} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Latch vs Bolt vs Lock — Key Distinctions</text>
        <line x1={408} y1={34} x2={942} y2={34} stroke="#e8b07a"/>
        {[
          ['LATCH:','Spring-loaded bolt with angled face (cam)'],
          ['','Self-engages when door closes (no key needed)'],
          ['','Released by handle/lever/button actuation'],
          ['','Provides: closure retention · NOT security'],
          ['',''],
          ['DEADBOLT:','Square-ended bolt · no angled cam face'],
          ['','Must be thrown manually (key or thumbturn)'],
          ['','Does NOT self-engage on closing'],
          ['','Provides: security against forced entry'],
          ['',''],
          ['LATCH + LOCK:','Latch gives easy closure · lock adds security'],
          ['','Locksets combine both in one hardware unit'],
          ['',''],
          ['Key forces:','F_spring keeps bolt extended (latched)'],
          ['','F_actuator retracts bolt against spring'],
          ['','F_cam retracts bolt as door closes (auto)'],
          ['',''],
          ['Standards:','ANSI/BHMA A156 · BS EN 12209'],
          ['','UL 10C (fire-rated) · NFPA 101 (egress)'],
          ['','ISO 5926 (door hardware terminology)'],
        ].map(([l,v],i) => (
          <g key={i}>
            <text x={410} y={48+i*14} fontSize="9.5"
              fontWeight={l?'700':'400'}
              fill={l?'#7a2e00':'#7a4a28'}>{l}</text>
            <text x={l?510:410} y={48+i*14} fontSize="9"
              fontFamily="'Courier New',monospace" fill="#a04010">{v}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Every latch shares the same core anatomy: a spring-loaded bolt with an angled cam face that self-closes, retracted by an actuator. The strike plate and keep are the fixed counterparts on the frame.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 2 — Spring Latch (Mortise & Tubular) cross-sections
// Two variants side by side with internal mechanism shown
// ─────────────────────────────────────────────────────────────────────
function DiagramSpringLatch() {
  const W = 960, H = 370;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Spring (Slam) Latch — Mortise &amp; Tubular Variants · Cross-Section</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arSL" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <pattern id="hatchSL" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="6" stroke="#d4874a" strokeWidth="1.5" opacity="0.45"/>
          </pattern>
          <pattern id="metalSL" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(30)">
            <line x1="0" y1="0" x2="0" y2="4" stroke="#c45a10" strokeWidth="0.8" opacity="0.35"/>
          </pattern>
        </defs>

        {/* ═══ LEFT: MORTISE SPRING LATCH ═══ */}
        <text x={210} y={20} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Mortise Spring Latch</text>
        <text x={210} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Rectangular case fits into door edge mortise</text>

        {/* Door edge */}
        <rect x={60} y={60} width={20} height={260} fill="url(#hatchSL)" stroke="#7a2e00" strokeWidth="1.5"/>
        {/* Strike keep */}
        <rect x={36} y={170} width={24} height={40} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5" opacity="0.8"/>
        <rect x={40} y={178} width={16} height={26} rx={2} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Case */}
        <rect x={80} y={80} width={120} height={220} rx={4}
          fill="url(#metalSL)" stroke="#7a2e00" strokeWidth="2.5"/>
        <rect x={80} y={80} width={120} height={220} rx={4}
          fill="none" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Faceplate */}
        <rect x={80} y={80} width={12} height={220} fill="#c45a10" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Bolt */}
        <rect x={55} y={179} width={37} height={22} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        {/* Angled face */}
        <polygon points="55,179 55,201 44,190" fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Follower / spindle hole */}
        <ellipse cx={165} cy={190} rx={14} ry={14} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="2"/>
        <ellipse cx={165} cy={190} rx={5} ry={5} fill="#7a2e00"/>

        {/* Spring */}
        {[0,1,2,3,4,5].map(i => (
          <path key={i}
            d={`M ${96+i*9} 188 Q ${100+i*9} 183 ${105+i*9} 188 Q ${109+i*9} 193 ${113+i*9} 188`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}
        <line x1={92} y1={190} x2={96} y2={190} stroke="#7a4a28" strokeWidth="1.8"/>
        <line x1={150} y1={190} x2={155} y2={190} stroke="#7a4a28" strokeWidth="1.8"/>

        {/* Lever follower arm */}
        <rect x={150} y={183} width={14} height={14} rx={2}
          fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Labels */}
        <line x1={56} y1={174} x2={30} y2={140} stroke="#c45a10" strokeWidth="1.2"/>
        <rect x={2} y={122} width={70} height={20} rx={3} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.2"/>
        <text x={37} y={135} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Latch bolt</text>

        <line x1={165} y1={205} x2={165} y2={250} stroke="#7a2e00" strokeWidth="1.2"/>
        <rect x={112} y={250} width={106} height={20} rx={3} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={165} y={263} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Spindle follower</text>

        <line x1={123} y1={188} x2={123} y2={140} stroke="#7a4a28" strokeWidth="1.2"/>
        <rect x={86} y={122} width={74} height={20} rx={3} fill="#fdf0e4" stroke="#7a4a28" strokeWidth="1.2"/>
        <text x={123} y={135} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a4a28">Return spring</text>

        <line x1={80} y1={120} x2={60} y2={100} stroke="#7a2e00" strokeWidth="1.2"/>
        <rect x={2} y={82} width={80} height={20} rx={3} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={42} y={95} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Faceplate / forend</text>

        {/* ═══ RIGHT: TUBULAR SPRING LATCH ═══ */}
        <text x={680} y={20} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Tubular Spring Latch</text>
        <text x={680} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Cylindrical case fits into bored hole in door</text>

        {/* Door (bored hole cross-section) */}
        <rect x={760} y={60} width={20} height={260} fill="url(#hatchSL)" stroke="#7a2e00" strokeWidth="1.5"/>
        <rect x={724} y={170} width={36} height={40} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5" opacity="0.8"/>
        <rect x={728} y={178} width={28} height={26} rx={2} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Tubular case (cylinder) */}
        <ellipse cx={680} cy={85} rx={55} ry={10} fill="#d4874a" stroke="#7a2e00" strokeWidth="2" opacity="0.6"/>
        <rect x={625} y={85} width={110} height={210} fill="url(#metalSL)" stroke="#7a2e00" strokeWidth="2.5"/>
        <rect x={625} y={85} width={110} height={210} fill="none" stroke="#7a2e00" strokeWidth="2.5"/>
        <ellipse cx={680} cy={295} rx={55} ry={10} fill="#d4874a" stroke="#7a2e00" strokeWidth="2" opacity="0.6"/>

        {/* Faceplate circle */}
        <ellipse cx={760} cy={190} rx={8} ry={28} fill="#c45a10" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Bolt */}
        <rect x={724} y={179} width={38} height={22} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <polygon points="724,179 724,201 712,190" fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Spring coils inside tube */}
        {[0,1,2,3,4,5].map(i => (
          <path key={i}
            d={`M ${635+i*12} 188 Q ${641+i*12} 182 ${647+i*12} 188 Q ${653+i*12} 194 ${659+i*12} 188`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}

        {/* Spindle (horizontal through centre of tube) */}
        <line x1={625} y1={190} x2={735} y2={190} stroke="#7a2e00" strokeWidth="3"/>
        <ellipse cx={680} cy={190} rx={18} ry={18} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="2"/>
        <ellipse cx={680} cy={190} rx={6} ry={6} fill="#7a2e00"/>

        {/* Labels */}
        <line x1={718} y1={179} x2={690} y2={145} stroke="#c45a10" strokeWidth="1.2"/>
        <rect x={622} y={126} width={70} height={20} rx={3} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.2"/>
        <text x={657} y={139} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Latch bolt</text>

        <line x1={680} y1={208} x2={680} y2={250} stroke="#7a2e00" strokeWidth="1.2"/>
        <rect x={634} y={250} width={90} height={20} rx={3} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={679} y={263} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Spindle hole</text>

        <line x1={650} y1={188} x2={640} y2={140} stroke="#7a4a28" strokeWidth="1.2"/>
        <rect x={590} y={122} width={82} height={20} rx={3} fill="#fdf0e4" stroke="#7a4a28" strokeWidth="1.2"/>
        <text x={631} y={135} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a4a28">Return spring</text>

        <line x1={760} y1={170} x2={810} y2={145} stroke="#7a2e00" strokeWidth="1.2"/>
        <rect x={808} y={126} width={92} height={20} rx={3} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={854} y={139} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Circular faceplate</text>

        {/* Divider */}
        <line x1={470} y1={20} x2={470} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
      </svg>
      <div style={S.dCaption}>
        Mortise latches fit into a rectangular slot routed into the door edge; tubular latches fit into a bored round hole. Both use the same spring-bolt mechanism — the case shape determines the installation method.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 3 — Deadlatch, Deadbolt, and Night Latch cross-sections
// Three security-focused latch types
// ─────────────────────────────────────────────────────────────────────
function DiagramDeadlatches() {
  const W = 960, H = 390;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Deadlatch · Deadbolt · Night Latch — Security Latch Types</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arDL" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <pattern id="hatchDL" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="6" stroke="#d4874a" strokeWidth="1.5" opacity="0.45"/>
          </pattern>
        </defs>

        {/* ═══ DEADLATCH ═══  (x: 20–280) */}
        <text x={150} y={20} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Deadlatch</text>
        <text x={150} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Auto-deadlocking spring latch</text>

        {/* Frame + strike */}
        <rect x={20} y={65} width={22} height={250} fill="url(#hatchDL)" stroke="#7a2e00" strokeWidth="1.5"/>
        <rect x={38} y={175} width={20} height={50} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5" opacity="0.8"/>
        <rect x={42} y={183} width={12} height={34} rx={2} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Case */}
        <rect x={90} y={80} width={130} height={220} rx={4} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Main bolt (cammed) */}
        <rect x={42} y={184} width={50} height={20} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <polygon points="42,184 42,204 30,194" fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Deadlocking plunger (small pin beside main bolt) */}
        <rect x={42} y={208} width={50} height={10} rx={2} fill="#7a2e00" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={67} y={231} textAnchor="middle" fontSize="7.5" fontWeight="700" fill="#7a2e00">Deadlocking</text>
        <text x={67} y={241} textAnchor="middle" fontSize="7.5" fill="#a04010">plunger</text>
        <line x1={67} y1={218} x2={67} y2={228} stroke="#7a2e00" strokeWidth="1"/>

        {/* Spring */}
        {[0,1,2,3].map(i => (
          <path key={i} d={`M ${100+i*11} 192 Q ${105+i*11} 187 ${110+i*11} 192 Q ${115+i*11} 197 ${120+i*11} 192`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}

        {/* How it deadlocks label */}
        <rect x={90} y={130} width={130} height={44} rx={3} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.2"/>
        <text x={155} y={145} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">When door closes:</text>
        <text x={155} y={157} textAnchor="middle" fontSize="7.5" fill="#a04010">plunger depressed by</text>
        <text x={155} y={168} textAnchor="middle" fontSize="7.5" fill="#a04010">strike → bolt locks</text>

        {/* ═══ DEADBOLT ═══  (x: 310–600) */}
        <text x={460} y={20} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Deadbolt</text>
        <text x={460} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Square bolt — key or thumbturn operated</text>

        {/* Frame */}
        <rect x={310} y={65} width={22} height={250} fill="url(#hatchDL)" stroke="#7a2e00" strokeWidth="1.5"/>
        <rect x={328} y={176} width={20} height={48} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5" opacity="0.8"/>
        <rect x={332} y={184} width={12} height={32} rx={2} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Case */}
        <rect x={380} y={80} width={150} height={220} rx={4} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Square bolt (no cam face) */}
        <rect x={332} y={185} width={50} height={30} rx={2} fill="#7a2e00" stroke="#7a2e00" strokeWidth="2"/>
        <text x={357} y={203} textAnchor="middle" fontSize="7.5" fontWeight="700" fill="#fff">BOLT</text>
        {/* Square end clearly shown */}
        <line x1={332} y1={185} x2={332} y2={215} stroke="#fff" strokeWidth="2"/>
        <text x={322} y={200} textAnchor="end" fontSize="7.5" fill="#7a2e00">square</text>
        <text x={322} y={210} textAnchor="end" fontSize="7.5" fill="#7a2e00">end →</text>

        {/* Cam mechanism / cylinder */}
        <ellipse cx={460} cy={200} rx={35} ry={35} fill="#d4874a" stroke="#7a2e00" strokeWidth="2" opacity="0.7"/>
        <ellipse cx={460} cy={200} rx={18} ry={18} fill="#c45a10" stroke="#7a2e00" strokeWidth="1.5"/>
        {/* Key slot */}
        <line x1={460} y1={186} x2={460} y2={200} stroke="#7a2e00" strokeWidth="3"/>
        <rect x={457} y={198} width={6} height={8} fill="#7a2e00"/>

        {/* Throw distance annotation */}
        <line x1={332} y1={240} x2={382} y2={240} stroke="#c45a10" strokeWidth="1.5" markerEnd="url(#arDL)"/>
        <line x1={382} y1={240} x2={332} y2={240} stroke="#c45a10" strokeWidth="1.5" markerEnd="url(#arDL)"/>
        <text x={357} y={254} textAnchor="middle" fontSize="8" fontWeight="700" fill="#c45a10">throw</text>
        <text x={357} y={264} textAnchor="middle" fontSize="7.5" fill="#a04010">25mm min</text>

        {/* Thumbturn */}
        <rect x={500} y={188} width={28} height={24} rx={4} fill="#2a6496" stroke="#7a2e00" strokeWidth="2"/>
        <text x={514} y={204} textAnchor="middle" fontSize="7.5" fontWeight="700" fill="#fff">TURN</text>
        <line x1={514} y1={200} x2={460} y2={200} stroke="#2a6496" strokeWidth="1.5" strokeDasharray="3,2"/>

        {/* Label: No cam */}
        <rect x={380} y={280} width={150} height={20} rx={3} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={455} y={293} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">No cam — does NOT self-close</text>

        {/* ═══ NIGHT LATCH ═══  (x: 650–940) */}
        <text x={800} y={20} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Night Latch (Rim Latch)</text>
        <text x={800} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Surface-mounted · self-closing with deadlock</text>

        {/* Frame + keep (surface-mounted) */}
        <rect x={650} y={65} width={22} height={250} fill="url(#hatchDL)" stroke="#7a2e00" strokeWidth="1.5"/>
        {/* Surface-mounted keep box */}
        <rect x={650} y={158} width={40} height={64} rx={3} fill="#a04010" stroke="#7a2e00" strokeWidth="2" opacity="0.85"/>
        <rect x={656} y={170} width={28} height={42} rx={2} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Surface-mounted case on door face */}
        <rect x={700} y={60} width={22} height={260} fill="url(#hatchDL)" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Rim case — surface mounted on inside face */}
        <rect x={722} y={130} width={120} height={120} rx={4} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Bolt */}
        <rect x={656} y={172} width={68} height={20} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <polygon points="656,172 656,192 644,182" fill="#a04010" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Snib (deadlock catch) */}
        <rect x={785} y={168} width={38} height={28} rx={3} fill="#7a2e00" stroke="#7a2e00" strokeWidth="1.5" opacity="0.8"/>
        <text x={804} y={182} textAnchor="middle" fontSize="7" fontWeight="700" fill="#fff">SNIB</text>
        <text x={804} y={192} textAnchor="middle" fontSize="7" fill="#fdf6ee">deadlock</text>

        {/* Exterior cylinder */}
        <ellipse cx={700} cy={192} rx={10} ry={22} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/>
        <text x={700} y={230} textAnchor="middle" fontSize="7.5" fill="#7a2e00">cylinder</text>

        {/* Spring */}
        {[0,1,2,3].map(i => (
          <path key={i} d={`M ${728+i*10} 180 Q ${733+i*10} 175 ${738+i*10} 180 Q ${743+i*10} 185 ${748+i*10} 180`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}

        {/* Labels */}
        <line x1={790} y1={168} x2={820} y2={140} stroke="#7a2e00" strokeWidth="1.2"/>
        <rect x={818} y={122} width={100} height={20} rx={3} fill="#fdf0e4" stroke="#7a2e00" strokeWidth="1.2"/>
        <text x={868} y={135} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Snib (hold-back)</text>

        <line x1={671} y1={172} x2={650} y2={140} stroke="#c45a10" strokeWidth="1.2"/>
        <rect x={618} y={122} width={60} height={20} rx={3} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.2"/>
        <text x={648} y={135} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Bolt</text>

        {/* Dividers */}
        <line x1={310} y1={10} x2={310} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
        <line x1={640} y1={10} x2={640} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
      </svg>
      <div style={S.dCaption}>
        The deadlatch plunger makes the bolt rigid once the door closes — a credit card cannot slip the bolt. The deadbolt has no spring or cam and must be manually thrown. The night latch combines a spring latch with a snib for interior hold-back.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 4 — Industrial & Mechanical Latches (toggle, draw, cam, hook)
// Four industrial latch types with geometry and force diagrams
// ─────────────────────────────────────────────────────────────────────
function DiagramIndustrialLatches() {
  const W = 960, H = 420;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Industrial Latch Types — Toggle · Draw · Cam · Hook-and-Eye</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arIL" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <marker id="arILg" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2a7a3b"/>
          </marker>
          <pattern id="hatchIL" width="5" height="5" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="5" stroke="#d4874a" strokeWidth="1.2" opacity="0.45"/>
          </pattern>
        </defs>

        {/* ═══ TOGGLE / OVER-CENTRE LATCH ═══ (top-left) */}
        <text x={118} y={18} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Toggle / Over-Centre</text>

        {/* Base plate */}
        <rect x={20} y={220} width={200} height={16} rx={3} fill="#7a2e00" opacity="0.7"/>
        {/* Keep / U-bracket */}
        <rect x={95} y={190} width={50} height={32} rx={2} fill="#a04010" stroke="#7a2e00" strokeWidth="2" opacity="0.8"/>
        <rect x={103} y={190} width={34} height={32} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Toggle handle (closed position) */}
        {/* Main arm */}
        <rect x={30} y={170} width={80} height={14} rx={3} fill="#c45a10" stroke="#7a2e00" strokeWidth="2" transform="rotate(-15,70,177)"/>
        {/* Link arm */}
        <rect x={100} y={176} width={18} height={45} rx={3} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/>
        {/* Pivot pin at base */}
        <circle cx={118} cy={219} r={5} fill="#7a2e00"/>
        {/* Pivot pin at link-arm top */}
        <circle cx={118} cy={178} r={4} fill="#7a2e00"/>
        {/* Handle pivot */}
        <circle cx={64} cy={170} r={4} fill="#7a2e00" transform="rotate(-15,70,177)"/>

        {/* Over-centre position indicator */}
        <text x={40} y={250} fontSize="7.5" fill="#2a7a3b" fontWeight="700">LOCKED (over-centre)</text>
        <text x={40} y={262} fontSize="7.5" fill="#7a4a28">F_load increases lock force</text>

        {/* Force arrow */}
        <line x1={119} y1={160} x2={119} y2={200} stroke="#c45a10" strokeWidth="2" markerEnd="url(#arIL)"/>
        <text x={130} y={180} fontSize="8" fill="#c45a10" fontWeight="700">F</text>

        {/* Clamping force arrow */}
        <line x1={119} y1={222} x2={119} y2={260} stroke="#2a7a3b" strokeWidth="2" markerEnd="url(#arILg)"/>
        <text x={130} y={244} fontSize="8" fill="#2a7a3b" fontWeight="700">F_clamp</text>

        <text x={118} y={290} textAnchor="middle" fontSize="8" fill="#7a4a28">Clamp load ∝ geometry</text>
        <text x={118} y={302} textAnchor="middle" fontSize="7.5" fill="#a04010">self-locking below centreline</text>

        {/* ═══ DRAW LATCH / HASP ═══ (top-right quadrant) */}
        <text x={355} y={18} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Draw Latch (Hasp &amp; Staple)</text>

        {/* Mounting plate */}
        <rect x={250} y={80} width={210} height={14} rx={3} fill="#7a2e00" opacity="0.7"/>

        {/* Staple (loop) */}
        <rect x={318} y={30} width={56} height={52} rx={3} fill="none" stroke="#7a2e00" strokeWidth="4"/>
        <rect x={326} y={38} width={40} height={36} rx={2} fill="#fdf6ee"/>
        <rect x={318} y={80} width={56} height={12} fill="#7a2e00" opacity="0.7"/>

        {/* Hasp plate */}
        <rect x={258} y={58} width={110} height={26} rx={3} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>

        {/* Slot in hasp that engages staple */}
        <rect x={318} y={58} width={50} height={26} rx={2} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1"/>

        {/* Hinge pivot at left */}
        <circle cx={265} cy={71} r={5} fill="#7a2e00"/>

        {/* Catch / keeper loop */}
        <rect x={258} y={94} width={60} height={14} rx={3} fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>
        <circle cx={288} cy={101} r={7} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={288} cy={101} r={3} fill="#7a2e00"/>

        {/* Padlock loop */}
        <text x={430} y={52} fontSize="8" fill="#7a4a28">← slot for padlock</text>
        <line x1={428} y1={50} x2={374} y2={58} stroke="#7a4a28" strokeWidth="1"/>

        <text x={355} y={135} textAnchor="middle" fontSize="8" fill="#7a4a28">Hinged hasp drops over staple</text>
        <text x={355} y={147} textAnchor="middle" fontSize="7.5" fill="#a04010">Padlock secures through slot</text>
        <text x={355} y={159} textAnchor="middle" fontSize="7.5" fill="#7a4a28">Common: boxes, cabinets, gates</text>

        {/* ═══ CAM LATCH ═══ (bottom-left) */}
        <text x={118} y={190} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Cam Latch</text>

        {/* Panel cutout */}
        <rect x={20} y={205} width={200} height={200} rx={4}
          fill="#fdf6ee" stroke="#7a2e00" strokeWidth="2.5" strokeDasharray="6,3"/>
        <text x={120} y={390} textAnchor="middle" fontSize="8" fill="#7a4a28">Panel (door face view)</text>

        {/* Quarter-turn body */}
        <circle cx={120} cy={300} r={32} fill="#d4874a" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={120} cy={300} r={22} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>

        {/* Slot */}
        <rect x={116} y={282} width={8} height={36} rx={2} fill="#fdf0e4"/>

        {/* Cam arm (behind panel) shown dashed */}
        <rect x={104} y={322} width={52} height={16} rx={3}
          fill="#7a2e00" stroke="#7a2e00" strokeWidth="1.5" opacity="0.7" strokeDasharray="4,2"/>
        <text x={130} y={333} textAnchor="middle" fontSize="7" fill="#fff">CAM ARM</text>

        {/* Panel lip they clamp against */}
        <rect x={20} y={338} width={200} height={6} fill="#a04010" opacity="0.6"/>
        <text x={120} y={356} textAnchor="middle" fontSize="7.5" fill="#a04010">Panel inner lip (cam presses here)</text>

        {/* Quarter-turn arrow */}
        <path d="M 148 280 A 30 30 0 0 1 152 325" fill="none" stroke="#c45a10" strokeWidth="2" markerEnd="url(#arIL)"/>
        <text x={162} y={303} fontSize="8" fill="#c45a10" fontWeight="700">¼ turn</text>

        {/* ═══ HOOK & KEEPER / DRAW BOLT ═══ (bottom-right) */}
        <text x={600} y={190} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Hook Latch &amp; Draw Bolt</text>

        {/* Frame */}
        <rect x={500} y={210} width={20} height={180} fill="url(#hatchIL)" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Keeper (eye bolt) */}
        <circle cx={510} cy={300} r={14} fill="none" stroke="#7a2e00" strokeWidth="4"/>
        <circle cx={510} cy={300} r={7} fill="#fdf6ee" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Draw bolt housing */}
        <rect x={540} y={270} width={130} height={60} rx={4} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Hook bolt */}
        <rect x={510} y={290} width={32} height={20} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        {/* Hook end */}
        <path d="M 510 290 Q 500 290 500 300 Q 500 310 510 310" fill="none" stroke="#c45a10" strokeWidth="5"/>

        {/* Draw bar / rod */}
        <rect x={540} y={292} width={125} height={14} rx={2} fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Actuating lever */}
        <rect x={660} y={270} width={30} height={58} rx={4} fill="#2a6496" stroke="#7a2e00" strokeWidth="2"/>
        <text x={675} y={299} textAnchor="middle" fontSize="7" fontWeight="700" fill="#fff">LEVER</text>
        <text x={675} y={311} textAnchor="middle" fontSize="7" fill="#fdf6ee">bolt</text>

        {/* Compression spring */}
        {[0,1,2,3].map(i => (
          <path key={i} d={`M ${556+i*14} 300 Q ${563+i*14} 294 ${570+i*14} 300 Q ${577+i*14} 306 ${584+i*14} 300`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}

        {/* Labels */}
        <text x={600} y={350} textAnchor="middle" fontSize="8" fill="#7a4a28">Lever pushes bolt into keeper eye</text>
        <text x={600} y={362} textAnchor="middle" fontSize="7.5" fill="#a04010">Used on gates, shed doors, cabinets</text>
        <text x={600} y={374} textAnchor="middle" fontSize="7.5" fill="#7a4a28">Spring returns bolt when lever released</text>

        {/* Dividers */}
        <line x1={240} y1={10} x2={240} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
        <line x1={480} y1={10} x2={480} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
        <line x1={240} y1={185} x2={480} y2={185} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
        <line x1={480} y1={185} x2={960} y2={185} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
      </svg>
      <div style={S.dCaption}>
        Toggle latches use over-centre geometry for vibration-resistant clamping. Cam latches require only a quarter-turn and are ideal for panel access doors. Draw latches and hook latches provide quick release without tools.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 5 — Automotive & Aerospace Latches (rotary, fork bolt, push-button)
// ─────────────────────────────────────────────────────────────────────
function DiagramSpecialLatches() {
  const W = 960, H = 380;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Rotary · Fork Bolt · Push-Button · Paddle Latches — Automotive &amp; Aerospace Types</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arSP" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <pattern id="hatchSP" width="5" height="5" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="5" stroke="#d4874a" strokeWidth="1.2" opacity="0.45"/>
          </pattern>
        </defs>

        {/* ═══ ROTARY LATCH ═══ */}
        <text x={120} y={20} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Rotary Latch</text>
        <text x={120} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Automotive doors · rotating claw</text>

        {/* Housing */}
        <rect x={40} y={55} width={160} height={160} rx={6} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Striker pin */}
        <circle cx={120} cy={100} r={10} fill="#7a2e00"/>
        <line x1={120} y1={55} x2={120} y2={90} stroke="#7a2e00" strokeWidth="4"/>
        <text x={120} y={50} textAnchor="middle" fontSize="8" fill="#7a2e00">striker pin</text>

        {/* Rotating claw */}
        <path d="M 120 110 Q 80 110 75 145 Q 70 175 105 185 Q 120 188 120 170"
          fill="#c45a10" stroke="#7a2e00" strokeWidth="2.5" opacity="0.85"/>

        {/* Pivot of claw */}
        <circle cx={120} cy={165} r={6} fill="#7a2e00"/>

        {/* Pawl (detent) */}
        <rect x={140} y={148} width={40} height={18} rx={3} fill="#d4874a" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={155} cy={157} r={5} fill="#7a2e00"/>
        {/* Pawl spring */}
        <line x1={178} y1={157} x2={190} y2={157} stroke="#7a4a28" strokeWidth="2" strokeDasharray="3,2"/>
        <text x={155} y={178} textAnchor="middle" fontSize="7.5" fill="#7a2e00">pawl</text>

        {/* Release direction */}
        <path d="M 90 185 A 35 35 0 0 0 120 200" fill="none" stroke="#c45a10" strokeWidth="2" markerEnd="url(#arSP)"/>
        <text x={65} y={210} fontSize="7.5" fill="#c45a10">release →</text>

        <text x={120} y={240} textAnchor="middle" fontSize="8" fill="#7a4a28">Claw traps striker on close</text>
        <text x={120} y={252} textAnchor="middle" fontSize="7.5" fill="#a04010">Pawl prevents rotation until released</text>

        {/* ═══ FORK BOLT ═══ */}
        <text x={350} y={20} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Fork Bolt Latch</text>
        <text x={350} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Bifurcated bolt · straddles striker</text>

        {/* Housing */}
        <rect x={270} y={55} width={160} height={160} rx={6} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Striker */}
        <rect x={340} y={55} width={20} height={60} rx={3} fill="#7a2e00"/>
        <text x={350} y={50} textAnchor="middle" fontSize="8" fill="#7a2e00">striker</text>

        {/* Fork bolt — U shaped */}
        <path d="M 315 115 L 315 185 Q 315 195 325 195 L 340 195 L 340 130"
          fill="none" stroke="#c45a10" strokeWidth="8" strokeLinejoin="round"/>
        <path d="M 385 115 L 385 185 Q 385 195 375 195 L 360 195 L 360 130"
          fill="none" stroke="#c45a10" strokeWidth="8" strokeLinejoin="round"/>

        {/* Slot between tines */}
        <rect x={340} y={115} width={20} height={80} fill="#fdf6ee"/>
        <text x={350} y={165} textAnchor="middle" fontSize="7" fill="#7a2e00">slot</text>

        {/* Detent pawl */}
        <rect x={395} y={145} width={30} height={20} rx={3} fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>
        <text x={410} y={158} textAnchor="middle" fontSize="7" fill="#7a2e00">detent</text>

        {/* Spring */}
        <line x1={270} y1={155} x2={313} y2={155} stroke="#7a4a28" strokeWidth="2" strokeDasharray="3,2"/>

        <text x={350} y={235} textAnchor="middle" fontSize="8" fill="#7a4a28">Both tines engage striker for</text>
        <text x={350} y={247} textAnchor="middle" fontSize="7.5" fill="#a04010">high pull-out resistance</text>
        <text x={350} y={259} textAnchor="middle" fontSize="7.5" fill="#7a4a28">Used: trunk lids, engine hoods</text>

        {/* ═══ PUSH-BUTTON LATCH ═══ */}
        <text x={590} y={20} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Push-Button Latch</text>
        <text x={590} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Spring-loaded · press to release</text>

        {/* Panel */}
        <rect x={510} y={55} width={160} height={24} rx={3} fill="url(#hatchSP)" stroke="#7a2e00" strokeWidth="2"/>

        {/* Button outer ring */}
        <circle cx={590} cy={67} r={18} fill="#d4874a" stroke="#7a2e00" strokeWidth="2.5"/>
        {/* Button face */}
        <circle cx={590} cy={64} r={13} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <text x={590} y={68} textAnchor="middle" fontSize="8" fontWeight="700" fill="#fff">PUSH</text>

        {/* Body below panel */}
        <rect x={565} y={79} width={50} height={80} rx={4} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2"/>

        {/* Bolt inside */}
        <rect x={515} y={120} width={50} height={16} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>

        {/* Spring inside body */}
        {[0,1,2].map(i => (
          <path key={i} d={`M ${570+i*10} 118 Q ${575+i*10} 112 ${580+i*10} 118 Q ${585+i*10} 124 ${590+i*10} 118`}
            fill="none" stroke="#7a4a28" strokeWidth="1.8"/>
        ))}

        {/* Press arrow */}
        <line x1={590} y1={30} x2={590} y2={52} stroke="#2a6496" strokeWidth="2" markerEnd="url(#arSP)"/>
        <text x={604} y={44} fontSize="8" fill="#2a6496" fontWeight="700">press</text>

        {/* Bolt retract arrow */}
        <line x1={512} y1={128} x2={540} y2={128} stroke="#c45a10" strokeWidth="2" markerEnd="url(#arSP)"/>
        <text x={520} y={145} fontSize="7.5" fill="#c45a10">retract</text>

        <text x={590} y={185} textAnchor="middle" fontSize="8" fill="#7a4a28">Push depresses spring · bolt retracts</text>
        <text x={590} y={197} textAnchor="middle" fontSize="7.5" fill="#a04010">Release → spring re-extends bolt</text>

        {/* ═══ PADDLE LATCH ═══ */}
        <text x={830} y={20} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#7a2e00">Paddle / T-Handle Latch</text>
        <text x={830} y={33} textAnchor="middle" fontSize="8.5" fill="#a04010">Flush-mount · tool-free access</text>

        {/* Panel */}
        <rect x={750} y={55} width={160} height={24} rx={3} fill="url(#hatchSP)" stroke="#7a2e00" strokeWidth="2"/>

        {/* Recessed paddle housing (flush) */}
        <rect x={790} y={55} width={80} height={80} rx={4} fill="#fdf4ec" stroke="#7a2e00" strokeWidth="2.5"/>

        {/* Paddle arm (T-shape) */}
        <rect x={810} y={68} width={40} height={12} rx={3} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>
        <rect x={826} y={56} width={8} height={22} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Pivot */}
        <circle cx={830} cy={110} r={5} fill="#7a2e00"/>

        {/* Linkage to rod */}
        <rect x={826} y={110} width={8} height={24} rx={2} fill="#d4874a" stroke="#7a2e00" strokeWidth="1.5"/>

        {/* Rod / bolt extending */}
        <rect x={750} y={145} width={80} height={14} rx={2} fill="#c45a10" stroke="#7a2e00" strokeWidth="2"/>

        {/* Keep plate */}
        <rect x={750} y={140} width={20} height={22} rx={2} fill="#a04010" stroke="#7a2e00" strokeWidth="1.5" opacity="0.8"/>
        <rect x={754} y={146} width={12} height={10} rx={1} fill="#fdf6ee"/>

        <text x={830} y={195} textAnchor="middle" fontSize="8" fill="#7a4a28">Paddle lifts → crank rotates bolt</text>
        <text x={830} y={207} textAnchor="middle" fontSize="7.5" fill="#a04010">Flush profile when closed</text>
        <text x={830} y={219} textAnchor="middle" fontSize="7.5" fill="#7a4a28">Toolbox, enclosures, equipment</text>

        {/* Dividers */}
        <line x1={240} y1={10} x2={240} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
        <line x1={480} y1={10} x2={480} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
        <line x1={720} y1={10} x2={720} y2={H-10} stroke="#e8b07a" strokeWidth="1" strokeDasharray="5,4"/>
      </svg>
      <div style={S.dCaption}>
        Rotary latches dominate automotive applications for their compact size and reliable self-closing. Fork bolts provide higher pull-out force. Paddle latches offer flush panel integration where aerodynamics or aesthetics require no protruding hardware.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// DIAGRAM 6 — Latch Selection Matrix (performance comparison heatmap)
// ─────────────────────────────────────────────────────────────────────
function DiagramSelectionMatrix() {
  const W = 960, H = 380;

  const latchTypes = [
    'Spring/Tubular',
    'Mortise Latch',
    'Deadbolt',
    'Deadlatch',
    'Night Latch',
    'Toggle/Over-ctr',
    'Cam Latch',
    'Rotary Latch',
    'Fork Bolt',
    'Paddle Latch',
    'Push-Button',
    'Hasp & Staple',
  ];

  const criteria = [
    'Self-closing',
    'Security level',
    'Ease of use',
    'Vibration resist.',
    'Flush profile',
    'Tool-free entry',
    'Weatherproof',
    'Load capacity',
    'Cost',
    'Install ease',
  ];

  // Scores 0(Poor)–4(Excellent)
  const data = [
  //  Self  Sec  Easy  Vib  Flush  Tool  Wthr  Load  Cost  Inst
    [  4,    1,   4,    1,    0,    4,    2,    2,    4,    3  ], // Spring/Tubular
    [  4,    2,   4,    1,    0,    4,    2,    3,    3,    2  ], // Mortise
    [  0,    4,   3,    3,    0,    2,    3,    4,    3,    2  ], // Deadbolt
    [  4,    4,   4,    2,    0,    4,    2,    3,    2,    2  ], // Deadlatch
    [  4,    3,   4,    1,    0,    4,    1,    2,    3,    3  ], // Night latch
    [  0,    2,   2,    4,    1,    3,    3,    4,    2,    2  ], // Toggle
    [  0,    1,   4,    2,    4,    4,    3,    2,    3,    4  ], // Cam latch
    [  4,    3,   4,    3,    2,    4,    3,    4,    2,    3  ], // Rotary
    [  4,    3,   4,    4,    1,    4,    3,    4,    2,    2  ], // Fork bolt
    [  0,    1,   4,    2,    4,    4,    3,    3,    2,    3  ], // Paddle
    [  0,    1,   4,    1,    3,    4,    2,    2,    3,    4  ], // Push-button
    [  0,    3,   3,    2,    1,    3,    2,    2,    4,    4  ], // Hasp & staple
  ];

  const labels = ['Poor','Fair','Good','V.Good','Excel.'];
  const colors = ['#c0392b','#d4874a','#e8b07a','#7a9e6a','#2a7a3b'];

  const labelW = 110, headerH = 44;
  const cellW = (W - labelW) / criteria.length;
  const cellH = (H - headerH - 30) / latchTypes.length;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Latch Selection Matrix — Performance Comparison Across Key Criteria</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Column headers */}
        {criteria.map((cr, j) => {
          const x = labelW + j * cellW + cellW / 2;
          return (
            <g key={j}>
              <rect x={labelW + j*cellW + 1} y={1} width={cellW-2} height={headerH-2}
                rx={3} fill="#fdf0e4" stroke="#e8b07a" strokeWidth="1"/>
              {cr.split('/').concat(['','','','','','','','','','']).slice(0,2).map((line, li) => (
                <text key={li} x={x} y={12+li*14} textAnchor="middle"
                  fontSize="8.5" fontWeight="700" fill="#7a2e00">{li===0?cr:''}</text>
              ))}
            </g>
          );
        })}

        {/* Rows */}
        {latchTypes.map((lt, i) => {
          const y = headerH + i * cellH;
          return (
            <g key={i}>
              <rect x={0} y={y} width={labelW-2} height={cellH-1}
                fill={i%2===0?'#fdf4ec':'#fdf6ee'} stroke="#e8c89a" strokeWidth="0.6"/>
              <text x={labelW-4} y={y+cellH/2+3.5} textAnchor="end"
                fontSize="8.5" fontWeight="700" fill="#7a2e00">{lt}</text>
              {data[i].map((score, j) => {
                const x = labelW + j * cellW;
                return (
                  <g key={j}>
                    <rect x={x+1} y={y+1} width={cellW-2} height={cellH-2}
                      fill={colors[score]} rx={2} opacity="0.72"/>
                    <text x={x+cellW/2} y={y+cellH/2+3.5} textAnchor="middle"
                      fontSize="7.5" fontWeight="700" fill="#fff">{labels[score]}</text>
                  </g>
                );
              })}
            </g>
          );
        })}

        {/* Legend */}
        {colors.map((c, i) => (
          <g key={i}>
            <rect x={labelW + i*88} y={H-24} width={12} height={12} fill={c} rx={2} opacity="0.8"/>
            <text x={labelW + i*88 + 15} y={H-14} fontSize="8" fill="#7a2e00">{labels[i]}</text>
          </g>
        ))}
        <text x={labelW + 5*88 + 40} y={H-14} fontSize="8" fontStyle="italic" fill="#7a4a28">← for each criterion</text>
      </svg>
      <div style={S.dCaption}>
        No latch excels at everything. The deadlatch offers the best balance of security and self-closing convenience. Toggle latches lead on vibration resistance. Cam and paddle latches win on flush profile.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// MAIN EXPORT
// ─────────────────────────────────────────────────────────────────────
export default function LatchTypes() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Types of Latches in Mechanical Engineering</h1>
      <p style={S.p}>
        A <strong>latch</strong> is a mechanical fastening device that holds two components in a closed position and can be released without a key —
        distinguishing it from a lock, which requires authorisation to open. Latches appear wherever panels, doors, enclosures, or access covers must
        be quickly and repeatedly opened and closed: from domestic door hardware to aerospace access panels and automotive bonnets.
      </p>
      <p style={S.p}>
        The fundamental mechanism is a <strong>spring-loaded bolt</strong> that self-engages when the door closes (due to an angled cam face),
        and is retracted by an actuator when opening is desired. This page covers the full family of latch types — their geometry,
        operating principles, material and force considerations, and selection guidelines.
      </p>

      <h2 style={S.h2}>Anatomy &amp; Terminology</h2>
      <DiagramLatchAnatomy />
      <Table2 rows={[
        ['Latch bolt','The moving element that projects into the strike to hold the door closed\nAngled (cammed) face allows self-engagement as door is pushed closed\nRetracted by actuating the handle, lever, paddle, or button\nTypically 13–19 mm projection (throw) for residential; 25–32 mm for commercial'],
        ['Strike plate / keep','Fixed counterpart on the door frame that receives the bolt\nBox strike: encloses bolt tip — provides best security against shimming\nLip strike: angled lip guides bolt into keep (older pattern)\nStrike must align precisely with bolt: ±2 mm tolerance typical'],
        ['Return spring','Maintains bolt in extended (latched) position when actuator released\nSized to ensure reliable self-closing against door friction and seals\nTypical spring force: 15–45 N · Fatigue life: 100,000+ cycles minimum\nSpring failure mode: bolt fails to re-extend → door appears closed but unlatched'],
        ['Cam / angled face','The bevelled leading face that converts door-closing force into bolt retraction\nAngle typically 60–75° from face of bolt · steeper = easier self-closing\nSelf-closing force depends on: spring stiffness, cam angle, door closing velocity\nWorn cam face → bolt fails to retract → door cannot close (latch "stands proud")'],
        ['Actuator','Device that retracts bolt for opening: lever, knob, thumb-turn, button, paddle\nMust overcome spring force plus friction: typically 15–60 N actuation force\nFollower / hub converts rotary handle motion to linear bolt retraction\nADA/accessibility standards: max 22 N actuation force, lever (not round knob) required'],
        ['Faceplate / forend','Metal plate on edge of door through which the bolt protrudes\nFlush faceplate: sits in routed recess in door edge · rebated: for rebated frames\nMaterial: stainless steel, brass, zinc alloy · finish must match other hardware\nSize: 65×16 mm (narrow) to 180×20 mm (broad) — choose for door thickness and style'],
      ]}/>

      <h2 style={S.h2}>Spring Latch — Mortise &amp; Tubular</h2>
      <DiagramSpringLatch />
      <Table2 rows={[
        ['Mortise latch','Fitted into a rectangular pocket (mortise) cut into the door edge\nCase dimensions: typically 65–75 mm backset × 38 mm wide × 19 mm thick\nBackset: distance from door edge to spindle centre — 44 mm or 57 mm standard\nAdvantage: strong, concealed case — door edge is not weakened by bore\nRequires routing: more complex installation than tubular, more secure result'],
        ['Tubular latch','Cylindrical case fits into a single bored hole (typically ⌀22–25 mm)\nFaceplate fits into a shallow routed recess on door edge\nBackset: 57 mm standard (64 mm also common for thicker doors)\nAdvantage: fast installation, no routing of door edge required\nLimitation: case smaller → spring weaker → slightly lower cycle life than mortise'],
        ['Rebated latches','For rebated (stepped) door pairs — faceplate has cranked/stepped profile\nBolt must reach further to engage keep on opposite rebate face\nAvailable in mortise and tubular variants · requires matching rebate keep\nCommon: French doors, double doors, lift/elevator doors'],
        ['Sash latch','Combined latch and keep on sash windows — push-button or turn-knob type\nHolds sash closed; provides minimal security · mainly closure function\nCresent sash latch: rotating hook engages keeper on opposite sash\nFasten both in closed position without preventing slight opening for ventilation'],
        ['Spring latch cycle life','Residential: minimum 100,000 cycles (BS EN 12209 Grade 3)\nCommercial: 200,000 cycles (Grade 4) · Heavy duty: 500,000+ (Grade 6)\nBolt actuation force must remain within ±20% over life\nWear points: bolt-to-faceplate slot, follower-to-spindle fit, spring seat'],
        ['Materials and finish','Case: zinc die cast, stainless steel, brass · Bolt: stainless, zinc, brass\nFinishes: polished chrome, satin stainless, antique brass, powder coat\nFor corrosive environments (coastal, pools): grade 316 stainless steel throughout\nFire doors: 30- or 60-min rated stainless latches only (intumescent seal compatible)'],
      ]}/>

      <h2 style={S.h2}>Deadlatch, Deadbolt &amp; Night Latch</h2>
      <DiagramDeadlatches />
      <Table2 rows={[
        ['Deadlatch','Spring latch with supplementary deadlocking plunger beside the main bolt\nWhen door closes: plunger contacts strike face → deadlocks main bolt in position\nDeadlocked bolt cannot be retracted by shimming (credit card, knife) from outside\nStandard for main entrance doors in residential: BS EN 12209, ANSI Grade 2\nRelease: interior handle always free; exterior requires key (or lever from outside)'],
        ['Deadbolt (deadlock)','Separate bolt with square (non-cammed) end — no spring, no self-closing\nThrown manually by key (exterior) or thumbturn (interior)\nMinimum 25 mm throw required for insurance compliance in UK/EU\nProvides: high resistance to forcing, kicking, credit-card attacks\nMulti-point locking: single key operates deadbolt plus multiple hook bolts simultaneously'],
        ['Night latch (rim latch)','Surface-mounted on inside face of door — does not require mortise or bore\nSelf-closing spring bolt: door snaps shut and latches automatically\nSnib/hold-back: small lever locks bolt retracted (hold door open) or locks bolt extended\nKey-lockable from outside via surface-mounted cylinder\nLimitation: relatively low security — do not use as sole fastening on external doors'],
        ['Bathroom bolt (WC latch)','Combination latch + indicator bolt in one unit\nTurn-knob on inside throws a deadbolt AND changes external indicator red/green\nEmergency release: external slot allows coin or flat blade override in emergencies\nPrimary requirement: simple operation, no key needed, visual occupied indicator'],
        ['Euro profile cylinder','Lock cylinder (plug) used in mortise deadlatches and deadbolts across Europe\nBS EN 1303: defines dimensions (30/30, 35/35, 40/40 each side of centre)\nBumping/picking: standard cylinders vulnerable; anti-bump/anti-pick grades available\nEuro profile: snap-safe versions (snap after 15 mm of extraction attempt)'],
        ['Anti-ligature latches','Specially designed to prevent ligature attachment — used in mental health facilities\nNo exposed handle arms, hooks, or protrusions that could support a noose\nTypically push-pad or flat flush paddle actuation\nRequires specific installation: compliance with HTM 08-01 (UK health estates guidance)'],
      ]}/>

      <h2 style={S.h2}>Industrial &amp; Mechanical Latches</h2>
      <DiagramIndustrialLatches />
      <Table2 rows={[
        ['Toggle / over-centre latch','Pivot linkage passes through dead-centre position to lock — geometry provides mechanical advantage\nOnce over-centre: load force increases clamping force (self-locking)\nAdjustable keeper: compensates for gasket compression, manufacturing tolerance\nVibration resistant: no secondary lock needed up to moderate vibration\nApplications: equipment covers, flight cases, enclosures, jigs and fixtures\nLoad range: light duty (50 N) to heavy-duty industrial (5000+ N)'],
        ['Cam latch','Quarter-turn operation: rotate slot/key × 90° to lock or unlock\nCam rotates behind panel to clamp against inner lip\nSizes: from miniature (⌀16 mm) to large panel (⌀60 mm)\nKeying options: standard, keyed-alike, keyed-different, master-keyed\nIP rating: dust/water tight variants available (gasket + stainless body)\nMaterial: zinc die cast, stainless steel, plastic for lightweight panels'],
        ['Draw latch (hasp & staple)','Hinged hasp plate drops over a fixed staple loop\nPadlock or pin secures through staple to prevent hasp lifting\nAdjustable draw tension: some designs pull mating surfaces together on closing\nVersatile: wide range of sizes and configurations\nWeakness: staple screws are the critical weak point — use through-bolts where possible'],
        ['Hook and keeper / draw bolt','Hook engages a fixed ring or eye on the frame\nSpring return pulls bolt back when actuator released\nLong-throw versions for heavy barn doors, gates, hatches\nBarrel bolt: simple push-slide mechanism without spring — common on shed/garden doors\nFlush bolt: concealed in door edge, activated by small knob — used on inactive door of a pair'],
        ['Slam latch (catch)','Simple: spring-loaded plunger snaps into a moulded catch body\nNo handle or actuator — finger pull to release in many designs\nTypical application: cabinet doors, appliance lids, lightweight enclosures\nMagnetic catch: no mechanical bolt — magnet holds door; minimal actuation force\nRoller catch: spring-loaded roller snaps past a cam catch — silent, gentle closure'],
        ['Compression latch','Threaded rod through bolt: rotating handle pulls mating surfaces together\nProvides compressive force across seal/gasket: achieves IP65/IP67 ratings\nUsed: weatherproof enclosures, marine hatches, junction boxes, railway rolling stock\nForce range: 500 N to 5000 N depending on thread pitch and lever length\nMaterial: stainless steel, non-sparking (ATEX rated versions for hazardous areas)'],
      ]}/>

      <h2 style={S.h2}>Automotive, Aerospace &amp; Specialist Latches</h2>
      <DiagramSpecialLatches />
      <Table2 rows={[
        ['Rotary latch','Rotating claw (detent rotor) traps the striker pin as door closes\nPawl locks the claw — prevents accidental release under vibration or crash loads\nSelf-closing: striker geometry guides claw to engagement automatically\nCrash resistance: designed to FMVSS 206 (US) / ECE Regulation 11 (EU)\nElectric release: solenoid or motor disengages pawl — enables keyless entry systems\nMaterials: heat-treated steel claw and pawl · zinc die cast body'],
        ['Fork bolt','Two-tine bolt straddles the striker rather than engaging a hole\nHigher pull-out force than single bolt of same section\nDetent pawl holds fork in engaged position\nUsed: bonnet/hood latches, boot/trunk lids where high loads expected\nSafety hook: secondary over-centre hook prevents bonnet opening at speed if primary fails\nRegulated: must withstand specified pull-out forces per vehicle safety standards'],
        ['Push-button latch','Single-axis push operation: button depresses spring → bolt retracts simultaneously\nResettable security versions: recessed button requires tool (pen tip) to depress\nPanel-mount: fits in standard punched hole (typically ⌀16 or 22 mm body)\nApplications: control panels, rackmount equipment, server enclosures\nKeying: cam-lock button versions provide security with quarter-turn key operation'],
        ['Paddle latch','Recessed paddle sits flush with panel surface when closed\nLift paddle → crank mechanism retracts bolt from frame\nDesigned for tool-free entry on electrical switchgear, HVAC units, floor-standing equipment\nKey-lockable: cylinder insert in paddle prevents unauthorised access\nRating: many are IP54 rated when closed (gasket on paddle face)\nStandards: IEC 60529 (IP rating), UL 508A (industrial control panel)'],
        ['Pelican/suitcase latch','Heavy-duty over-centre toggle with carry handle integration\nWidely used: Pelican/Storm cases, flight equipment cases, military hardware\nStainless or acrylonitrile version for corrosion resistance\nAutomatic vs manual carry handle lift integration\nLoad rating: 200–1000 N typical clamping force\nFlight rated versions: comply with IATA load requirements for checked baggage'],
        ['Pawl / ratchet latch','Ratcheting mechanism: engages progressively as door closes, ratchets past teeth\nMultiple engagement points: good for warped doors or uneven gasket compression\nRelease: lever lifts pawl off ratchet teeth simultaneously\nApplications: aircraft access panels, bus body side doors, heavy plant access hatches\nSelf-adjusting: compensates for wear and gasket set without readjustment'],
      ]}/>

      <h2 style={S.h2}>Latch Selection Matrix</h2>
      <DiagramSelectionMatrix />
      <Table2 rows={[
        ['Self-closing vs manual','Self-closing latches (spring bolt) simplify operation but require cam geometry\nNon-self-closing (deadbolt, toggle) require deliberate actuation on close — better for security or clamping\nChoice depends on: frequency of use, operator skill, need for positive confirmation of closure\nHigh-cycle applications (>500 opens/day): tubular latch preferred — simpler, more durable spring mechanism'],
        ['Security grading','ANSI/BHMA Grade 1: heavy commercial · Grade 2: light commercial · Grade 3: residential\nBS EN 12209 Grade 1–7 (Grade 1 = lowest, Grade 7 = highest security)\nBS EN 1630 (attack resistance): 1–6 grades of resistance to physical attack\nInsurance and standards bodies specify minimum grades for external doors, fire exits, rated enclosures'],
        ['Environmental ratings','IP54: protected against dust and water splash — minimum for outdoor latches\nIP65: dust-tight + water jet resistant — outdoor enclosures, HVAC equipment\nIP67: immersion to 1 m for 30 minutes — marine, wash-down industrial\nATEX: explosive atmosphere rating — special materials, no sparking, non-magnetic options\nCoastal/marine: grade 316 stainless steel body and bolt minimum; Monel or titanium for severe service'],
        ['Fire door requirements','Fire-rated latches must maintain operation throughout rated period (30, 60, 90, 120 min)\nIntumescent seals: must not obstruct bolt projection or strike engagement\nCE marking required in UK/EU for fire door latches: EN 1634-1 test\nSelf-closing required on fire doors: latch spring stiffness part of closing force calculation\nNo hold-open devices unless thermally-activated (fusible link) type'],
        ['Cycle life and maintenance','Specify cycle life to match expected service: 100k cycles ≈ 10 years at 30 opens/day\nLubrication: petroleum-based greases attack some seals — use PTFE or silicone grease\nWear monitoring: measure bolt projection and actuation force periodically\nReplacement trigger: bolt projection reduced >2 mm OR actuation force increased >50%\nSpare parts: keep one spare latch per 20 installations for rapid replacement'],
        ['Material selection guide','Zinc die cast: low cost, good precision, moderate corrosion resistance · indoor/protected\nStainless steel 304: good corrosion resistance, moderate hardness · general outdoor\nStainless steel 316: marine/chemical environments · superior chloride resistance\nBrass: decorative, low friction, good machinability · architectural applications\nEngineering plastics (PA66, POM): lightweight, non-magnetic, non-conductive · electronics enclosures'],
      ]}/>

      <h2 style={S.h2}>Forces, Standards &amp; Design Considerations</h2>
      <Table2 rows={[
        ['Latch force analysis','F_spring: spring preload keeping bolt extended — typically 15–45 N\nF_cam: closing force required to cam bolt in (F_spring / tan(cam_angle))\nF_actuator: force needed at handle to retract bolt = F_spring × (radius_ratio)\nF_clamp (toggle): F_applied × sin(link_angle) / cos(over-centre_angle)'],
        ['Strike alignment tolerance','Bolt and strike must align within ±2 mm vertically and horizontally\nDoor sag over time: hinge wear causes strike misalignment — use adjustable strikes\nThermal expansion: large steel doors can expand 3–5 mm — strike must accommodate\nBox strike preferred: 12 mm clearance all around bolt tip for reliable engagement\nFire doors: strike material must match frame material for compatible thermal expansion'],
        ['Acoustic & vibration','Toggle latches: lock force proportional to applied load — good vibration resistance\nSpring latches: bolt can be vibrated back if spring force insufficient\nRailway EN 14752: vibration resistance test for rolling stock access doors\nMIL-L-6140: US military specification for aircraft latch vibration requirements\nSolution: dual-detent or pawl mechanism prevents bolt retraction under vibration'],
        ['Fail-safe vs fail-secure','Fail-safe: power loss → latch releases (fire egress, elevator doors)\nFail-secure: power loss → latch locks (security applications, safes)\nElectric strikes: solenoid pulls strike jaw open on signal (fail-safe typical)\nElectromagnetic locks (maglocks): fail-safe inherently — power loss = door unlocks\nElectric bolt (electric deadbolt): can be specified either way with different wiring'],
        ['Accessibility (ADA/DDA)','Maximum actuation force: 22 N (5 lbf) for lever handles — ADAAG 4.13.9\nHandle type: lever or pull bar — not round knob (requires tight grip)\nHandle height: 900–1100 mm from floor in most codes\nEmergency egress: single-motion release required — no key, no tight grasp\nUK: PAS 24, BS 8300 (Approved Document M) specify accessible hardware requirements'],
        ['Torque and mechanical advantage','Round knob: mechanical advantage ≈ R_knob / R_follower — typically 3:1 to 5:1\nLever handle: moment = F × L, where L = lever arm from pivot to grip point\nLonger lever → less force required → easier for weak or arthritic users\nPaddle latch: crank geometry — mechanical advantage depends on throw arm length\nToggle latch: varies 5:1 to 20:1 depending on geometry — consult manufacturer curves'],
      ]}/>

      <InfoBox title="Key Terms &amp; Formulae" items={[
        "Bolt retraction force:  F_retract = F_spring / tan(β)  where β = cam face angle from door surface",
        "Toggle clamping force:  F_clamp = F_applied × (a/b) × (1/sin θ)  where θ = angle at toggle dead-centre",
        "Latch backset:  distance from door edge to spindle centre  (44 mm or 57 mm standard)",
        "Bolt throw:  projection of bolt from faceplate  (13–19 mm residential · 25+ mm security)",
        "Spring cycle life: N = (F_max / F_endurance)^b × N_endurance  (Basquin law for steel springs)",
        "Strike alignment tolerance: ±2 mm horizontal · ±3 mm vertical (typical box strike)",
        "Dead-centre condition (toggle): link geometry such that pull-out force produces zero opening moment",
        "IP rating formula:  IP XY — X = solid protection (0–6) · Y = liquid protection (0–9K)",
        "ADA max actuation force:  22 N (5 lbf) at lever tip per ADAAG 4.13.9",
        "Security grade (BS EN 12209): Grade 3 = residential · Grade 4/5 = commercial · Grade 6/7 = high security",
        "Cam latch engagement:  F_clamp = F_torque / R_cam · cos(cam_angle_from_centreline)",
        "Night latch snib:  deadlocks bolt in closed position — bolt cannot be retracted from either side",
      ]}/>
    </div>
  );
}